var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    HOME: 0,
    EXPERIENCE: 0,
    YOUTUBE: 0,
    WHOAMI: 0,
    PROJECTS: 0,
};
var visiblePageReducer = createSlice({
    name: 'visible-page',
    initialState: initialState,
    reducers: {
        setVisiblePage: function (state, _a) {
            var _b;
            var payload = _a.payload;
            var page = payload.page, intersectionRatio = payload.intersectionRatio;
            return __assign(__assign({}, state), (_b = {}, _b[page] = intersectionRatio, _b));
        },
    },
});
export var setVisiblePage = visiblePageReducer.actions.setVisiblePage;
export default visiblePageReducer.reducer;
